import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackPageView } from '../lib/analytics';

// SPA のページ遷移ごとに page_view を送る（GA4。測定ID未設定・管理画面では何もしない）
export default function RouteTracker() {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    trackPageView(i18n.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return null;
}
